const Config = {
    teamHrApi: 'https://hrm.nuroil.com/api/v1/task/',
    localApi: 'https://devtask.nuroil.com/api/',
    uploadApi: 'https://devtask.nuroil.com/',
    personPicURL: 'https://hrm.nuroil.com/public_html/',
    userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
}


/** Base URL for static uploads (no trailing slash, no /api path). Use for attachment/image links. */
export function getUploadBaseUrl() {
    const base = (Config.uploadApi || Config.localApi || '').replace(/\/+$/, '');
    return base.replace(/\/api\/?$/i, '') || base;
}

export default Config;